import axios, { AxiosInstance, AxiosError } from "axios";

export interface ApiError {
  message: string;
  code?: string;
  status?: number;
}

declare global {
  interface ImportMetaEnv {
    readonly VITE_API_BASE_URL?: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError<any>) => {
      const apiError: ApiError = {
        message:
          error.response?.data?.message ||
          error.message ||
          "エラーが発生しました",
        code: error.response?.data?.code,
        status: error.response?.status,
      };

      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        window.location.href = "/login";
      }

      return Promise.reject(apiError);
    }
  );

  return instance;
};

const getApiBaseUrl = (): string => {
  if (
    typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_API_BASE_URL
  ) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  return "http://localhost:3000/api/v1";
};

export const api = createAxiosInstance(getApiBaseUrl());

export default api;
